import type { ISelectedTrip } from "@b2bportal/core-types";

export function toFetchCfarOffersParams(
  selectedTrip:
    | Pick<ISelectedTrip, "tripId" | "returnFareId" | "outgoingFareId">
    | undefined
) {
  if (!selectedTrip) {
    return undefined;
  }
  const tripId = selectedTrip.tripId;
  const fareId = selectedTrip.returnFareId
    ? selectedTrip.returnFareId
    : selectedTrip.outgoingFareId;

  if (tripId && fareId) {
    return {
      tripId,
      fareId,
    };
  }

  return undefined;
}
